const POPUP_PREFIX = "PopUp";

export const POPUP_CLASSES = {
  root: `${POPUP_PREFIX}-root`,
  title: `${POPUP_PREFIX}-title`,
  content: `${POPUP_PREFIX}-content`,
  description: `${POPUP_PREFIX}-description`,
  closeButton: `${POPUP_PREFIX}-closeButton`,
  actions: `${POPUP_PREFIX}-actions`,
  actionButton: `${POPUP_PREFIX}-actionButton`,
  titleWithDisabledCloseButton: `${POPUP_PREFIX}-titleWithDisabledCloseButton`,
};
